//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import search from "@/components/search/index.vue";
import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue";
import {
	getListByCode,
	getLIstByCodeSimple
} from "@/common/js/dictionary.js";
export default {
	data() {
		return {
			name: "", //搜索名称
			lineType: "", //搜索类型
			playDays: "", //搜索天数
			sortType: "4", //排序
			//列表页的请求参数
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false
			},
			count: 0,
			end: false,
			dataList: {
				dataList1: [],
				dataList2: []
			},
			list: [],
			menu: [{
					title: "线路类型",
					detailList: [{
						name: "",
						code: ""
					}]
				},
				{
					title: "线路天数",
					detailList: [{
						name: "",
						code: ""
					}]
				},
				{
					title: "综合排序",
					style: "columnar",
					detailList: [
						{
							name: "默认",
							code: "4"
						},
						{
							name: "销量高到低",
							code: "1"
						},
						{
							name: "价格高到低",
							code: "2"
						},
						{
							name: "价格低到高",
							code: "3"
						},
						{
							name: "评分高到低",
							code: "6"
						}
					]
				}
			]
		};
	},
	components: {
		search,
		uniLoadMore
	},
	onReady() {







	},
	async onLoad() {
		this.menu[0].detailList = await getListByCode("", "/weChat/lineOrder/queryLineTypes", true);
		this.menu[1].detailList = await getLIstByCodeSimple("playDate");
		this.querySearchData();
	},
	onPullDownRefresh() {
		this.dataList.dataList1 = []
		this.dataList.dataList2 = []
		this.page.currentPage = 1;
		this.queryData("refresh");
	},
	onReachBottom() {
		if (this.dataList.dataList1.length + this.dataList.dataList2.length < this.count) {
			this.queryData();
		}
	},
	methods: {
		mountMenu(arg) {
			let index = arg || 0
			const query = uni.createSelectorQuery().in(this);
			query.selectAll('.routeList').boundingClientRect(res => {
				if (this.list.length > index) {
					let height1 = res[0].height
					let height2 = res[1].height
					if (height1 <= height2) {
						this.dataList[`dataList1`].push(this.list[index])
					} else {
						this.dataList[`dataList2`].push(this.list[index])
					}
					this.$nextTick(() => {
						this.mountMenu(index + 1)
					})
				}
			}).exec()
		},
		
		// 搜索
		querySearchData() {
			this.list = []
			this.dataList.dataList1 = []
			this.dataList.dataList2 = []
			this.page.currentPage = 1;
			this.queryData();
		},
		//搜索确认
		confirm(item) {
			if (item.index === 0) {
				this.lineType = item.code || "";
			} else if (item.index === 1) {
				this.playDays = item.code || "";
			} else if (item.index === 2) {
				this.sortType = item.code || "";
			}
			this.querySearchData();
		},
		//搜索重置
		reset(index) {
			if (index === 0) {
				this.lineType = "";
			} else if (index === 1) {
				this.playDays = "";
			} else if (index === 2) {
				this.sortType = "4";
			}
			this.querySearchData();
		},
		//名称搜索框
		nameInput(e) {
			this.name = e.target.value;
		},
		// 列表获取
		queryData(status) {
			this.page.loading = true;
			this.$ajax({
				method: "post",
				url: "/weChat/lineOrder/queryPage",
				data: {
					...this.page,
					productName: this.name || "",
					lineType: this.lineType || "",
					playDays: this.playDays || "",
					sortType: this.sortType || "4"
				}
			}).then(res => {
				this.list.push.apply(this.list, this.renderData(res.data));
				this.list.map(t => {
					if (t.productName.length > 23) {
						t.productName = t.productName.substr(0, 23) + '...'
					} else {
						return t.productName
					}
				})
				this.page.loading = false;
				this.count = res.count;
				if (this.list.length + this.dataList.dataList1.length + this.dataList.dataList2.length >= this.count) {
					this.end = true;
				}
				this.page.currentPage += 1;
				if (status === "refresh") {
					uni.stopPullDownRefresh();
				}
				this.$nextTick(() => {
					this.mountMenu()
				})
			});
		},
		renderData(data) {
			return data.map(t => {
				return {
					...t,
					productId: t.productId,
					productName: t.productName,
					cover: t.cover,
					lineTypeName: t.lineTypeName ? t.lineTypeName.split(',') : []
				}
			})
		}
	}
};
